/*
Monotype Foundry Platform API
Version 1.0.0

Definition: Binary

Properties:
  createdAt: string
  status: string
  defaultSampleString: string
  fileName: string
  fileSize: number
  fileType: string
  fontInfo: object
  fontInfoComplete: boolean
  monotypeTags: array
  hasCriticalErrors: boolean
  id: string
  isEdit: boolean
  avStatus: string
  md5Checksum: string
  visualHash: string
  submissionId: string
  inventoryIngestionId: string
  uploadSuccessful: boolean
  uploadedToRenderer: boolean
  validationLock: boolean
  validationResult: object
*/

var Binary = (function () {
  function validateBinary (arg) {
    // Validate fontInfoComplete
    if (arg.fontInfoComplete && !(typeof arg.fontInfoComplete === 'boolean')) {
      throw new Error('Binary.fontInfoComplete: Wrong type: Got \'' + (typeof arg.fontInfoComplete) + '\', but expected: \'boolean\'')
    }
    // Validate monotypeTags
    if (arg.monotypeTags && !(Array.isArray(arg.monotypeTags))) {
      throw new Error('Binary.monotypeTags: Wrong type: Got \'' + (typeof arg.monotypeTags) + '\', but expected: \'array\'')
    }
    // Validate hasCriticalErrors
    if (arg.hasCriticalErrors && !(typeof arg.hasCriticalErrors === 'boolean')) {
      throw new Error('Binary.hasCriticalErrors: Wrong type: Got \'' + (typeof arg.hasCriticalErrors) + '\', but expected: \'boolean\'')
    }
    // Validate avStatus
    if (arg.avStatus && !(typeof arg.avStatus === 'string')) {
      throw new Error('Binary.avStatus: Wrong type: Got \'' + (typeof arg.avStatus) + '\', but expected: \'string\'')
    }
    // Validate uploadedToRenderer
    if (arg.uploadedToRenderer && !(typeof arg.uploadedToRenderer === 'boolean')) {
      throw new Error('Binary.uploadedToRenderer: Wrong type: Got \'' + (typeof arg.uploadedToRenderer) + '\', but expected: \'boolean\'')
    }
  }
  function buildBinary (arg) {
    var Binary = arg
    // Complete fontInfoComplete
    // Expected Type: boolean
    Binary.fontInfoComplete = Binary.fontInfoComplete || false
    // Complete monotypeTags
    // Expected Type: array
    Binary.monotypeTags = Binary.monotypeTags || []
    // Complete hasCriticalErrors
    // Expected Type: boolean
    Binary.hasCriticalErrors = Binary.hasCriticalErrors || false
    // Complete avStatus
    // Expected Type: string
    Binary.avStatus = Binary.avStatus || ''
    // Complete uploadedToRenderer
    // Expected Type: boolean
    Binary.uploadedToRenderer = Binary.uploadedToRenderer || false
    return Binary
  }
  return {
    validate: validateBinary,
    build: buildBinary
  }
})()

module.exports = Binary
